// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__pg-RL","myModalContent":"MyModal_myModalContent__gQngB","active":"MyModal_active__9tL7C"};